import React from 'react';

const SpacingList = () => {
  const spacingVariables = [
    '0',
    'xs',
    'sm',
    'm-sm',
    'md',
    'm-lg',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    '7xl',
    '8xl',
    '9xl',
  ];
  return (
    <div className="items">
      <div>
        <p className="editorial-large semibold">
          Spacing (
          <a
            className="editorial-large semibold underline"
            href="https://www.figma.com/design/6xudIyDqmcUDdRu0OZxjQP/GLOW-UI?node-id=18983-1562&t=u1Volg6SHkGPX5MG-4"
          >
            Reference
          </a>
          )
        </p>
      </div>
      <div className="column">
        <p className="body">
          All padding and margin listed below can be applied globally using classes mentioned (
          <code className="code-example">class="p-xs"</code>)
        </p>
        <h6 className="editorial">Padding (all sides)</h6>
        <div className="section-wrap">
          <>
            {spacingVariables.map((key) => (
              <div key={key} className={`padding-box p-${key}`}>
                <code>p-{key}</code>
              </div>
            ))}
          </>
        </div>
        <h6 className="editorial">Margin (all sides)</h6>
        <div className="section-wrap">
          <>
            {spacingVariables.map((key) => (
              <div className="margin-box">
                <div key={key} className={`margin-box--box p-md m-${key}`}>
                  <code>m-{key}</code>
                </div>
              </div>
            ))}
          </>
        </div>
        <h5 className="editorial">Padding (left & right)</h5>
        <div className="section-wrap">
          <>
            {spacingVariables.map((key) => (
              <div key={key} className={`padding-box py-md px-${key}`}>
                <code>px-{key}</code>
              </div>
            ))}
          </>
        </div>
        <h6 className="editorial">Margin (left & right)</h6>
        <div className="section-wrap">
          <>
            {spacingVariables.map((key) => (
              <div className="margin-box">
                <div key={key} className={`margin-box--box p-md mx-${key}`}>
                  <code>mx-{key}</code>
                </div>
              </div>
            ))}
          </>
        </div>
        <h6 className="editorial">Padding (top & bottom)</h6>
        <div className="section-wrap">
          <>
            {spacingVariables.map((key) => (
              <div key={key} className={`padding-box px-md py-${key}`}>
                <code>py-{key}</code>
              </div>
            ))}
          </>
        </div>
        <h6 className="editorial">Margin (top & bottom)</h6>
        <div className="section-wrap">
          <>
            {spacingVariables.map((key) => (
              <div className="margin-box">
                <div key={key} className={`margin-box--box p-md my-${key}`}>
                  <code>my-{key}</code>
                </div>
              </div>
            ))}
          </>
        </div>
        <h6 className="editorial">Additional Padding & Margin Classes:</h6>
        <p className="body">
          To add padding or margin to just one side of an element, use format:{' '}
          <code className="code-example">class="mr-lg"</code>
        </p>
        <p className="body-large semibold">Examples:</p>
        <div className="section-wrap">
          <div className="column">
            <p className="mb-md">
              Margin right: <code className="code-example">.mr-lg</code>
            </p>
            <div className="margin-box">
              <div className={`margin-box--box p-md mr-lg`}>
                <code>mr-lg</code>
              </div>
            </div>
          </div>
          <div className="column">
            <p className="mb-md">
              Margin top: <code className="code-example">.mt-lg</code>
            </p>
            <div className="margin-box">
              <div className={`margin-box--box p-md mt-lg`}>
                <code>mt-lg</code>
              </div>
            </div>
          </div>
          <div className="column">
            <p className="mb-md">
              Margin bottom: <code className="code-example">.mb-lg</code>
            </p>
            <div className="margin-box">
              <div className={`margin-box--box p-md mb-lg`}>
                <code>mb-lg</code>
              </div>
            </div>
          </div>
          <div className="column">
            <p className="mb-md">
              Margin left: <code className="code-example">.ml-lg</code>
            </p>
            <div className="margin-box">
              <div className={`margin-box--box p-md ml-lg`}>
                <code>ml-lg</code>
              </div>
            </div>
          </div>
        </div>
        <div className="section-wrap">
          <div className="column">
            <p className="mb-md">
              Padding right: <code className="code-example">.pr-lg</code>
            </p>
            <div className={`padding-box py-md pr-lg`}>
              <code>pr-lg</code>
            </div>
          </div>
          <div className="column">
            <p className="mb-md">
              Padding top: <code className="code-example">.pt-lg</code>
            </p>

            <div className={`padding-box px-md pt-lg`}>
              <code>pt-lg</code>
            </div>
          </div>
          <div className="column">
            <p className="mb-md">
              Padding bottom: <code className="code-example">.pb-lg</code>
            </p>
            <div className={`padding-box px-md pb-lg`}>
              <code>pb-lg</code>
            </div>
          </div>
          <div className="column">
            <p className="pb-md">
              Padding left: <code className="code-example">.pl-lg</code>
            </p>
            <div className={`padding-box py-md pl-lg`}>
              <code>pl-lg</code>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpacingList;
